import React from 'react';
import styled from 'styled-components';

export enum FontSizes {
  l = 'l',
  m = 'm',
  s = 's',
  xs = 'xs',
  xxs = 'xxs',
}

interface Props {
  title: string;
  size: FontSizes;
  extraMargin?: boolean;
  className?: string;
}

export const AggregationHeader: React.FC<Props> = React.memo(({ title, size, extraMargin = false, className }) => {
  if (!title) return null;
  return (
    <StyledH3 tabIndex={0} size={size} extraMargin={extraMargin} className={className}>
      {title}
    </StyledH3>
  );
});

const StyledH3 = styled.h3<{ size: FontSizes; extraMargin: boolean }>`
  ${props =>
    props.extraMargin
      ? `
      margin: ${`0 ${props.theme.pxToRem(20)} ${props.theme.pxToRem(12)}`};
    `
      : `margin: ${`0 0 ${props.theme.pxToRem(20)}`};`}
  color: ${props => props.theme.colors.neutralGrey8};
  font-size: ${props => props.theme.pxToRem(18)};
  font-weight: ${props => props.theme.fontWeights.bold};
`;
